<p mat-dialog-title class="custom-header-modal-attach">
  <span class="ml-0 custom-title-modal-attach custom-check-email">
    {{ "CheckYourEmail.texto" | translate }}
  </span>
  <a href="javascript:void(0)" (click)="close()">
    <img
      src="/pictures/ServlyClose.png"
      alt="Servly Close Image"
      class="custom-header-img-modal-attach"
      width="21"
      height="21"
    />
  </a>
</p>

<mat-dialog-content>
  <p class="custom-text-primary-modal-remove-service custom-text-check-email">
    {{ "OnceYouHaveVerifiedYourEmailAddress.texto" | translate }}
  </p>
  <div class="col-12 text-center">
    <p
      class="col-12 custom-text-primary-modal-remove-service custom-text-check-email"
    >
      {{ "DidntYouReceiveAnyEmail.texto" | translate }}
      &nbsp;
      <a
        href="javascript:void(0)"
        class="custom-resend-link"
        (click)="resendEmail()"
        *ngIf="!sendEmail"
      >
        {{ "ResendEmail.texto" | translate }}
      </a>
      <span class="custom-resend-text" *ngIf="sendEmail">
        {{ "EmailSent.texto" | translate }}
      </span>
    </p>
  </div>
</mat-dialog-content>
